export default __webpack_public_path__ + "static/media/fieldraid.a6002cad.mp4";